/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dress_The_BookInputs */

const en_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dress the Book`)
};

const es_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vestir el Libro`)
};

const fr_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habiller le Livre`)
};

const de_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleiden Sie das Buch`)
};

const ja_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本を装飾する`)
};

const zh_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`装帧书籍`)
};

const ar_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تزيين الكتاب`)
};

const id_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rias Bukunya`)
};

const it_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vesti il Libro`)
};

const ru_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оформить Книгу`)
};

const pt_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vestir o Livro`)
};

const ko_dress_the_book = /** @type {(inputs: Dress_The_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`책 디자인하기`)
};

/**
* | output |
* | --- |
* | "Dress the Book" |
*
* @param {Dress_The_BookInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dress_the_book = /** @type {((inputs?: Dress_The_BookInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dress_The_BookInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dress_the_book(inputs)
	if (locale === "es") return es_dress_the_book(inputs)
	if (locale === "fr") return fr_dress_the_book(inputs)
	if (locale === "de") return de_dress_the_book(inputs)
	if (locale === "ja") return ja_dress_the_book(inputs)
	if (locale === "zh") return zh_dress_the_book(inputs)
	if (locale === "ar") return ar_dress_the_book(inputs)
	if (locale === "id") return id_dress_the_book(inputs)
	if (locale === "it") return it_dress_the_book(inputs)
	if (locale === "ru") return ru_dress_the_book(inputs)
	if (locale === "pt") return pt_dress_the_book(inputs)
	return ko_dress_the_book(inputs)
});